<script setup>
import { ref } from "vue";

const props = defineProps({
  dialogId: {
    type: String,
    default: "RaceRegistrationNoSelectDialog",
  },
  title: {
    type: String,
    default: "レース選択",
  },
});

const darkModeOn = window.matchMedia("(prefers-color-scheme: dark)").matches;
const registrationNo = ref(0);
const emit = defineEmits(["result"]);

function onClick(emitfunc, resdata) {
  emit(emitfunc, resdata);
}

// 登録番号数値チェック(0-9999)
function registrationNoCheck() {
  if (registrationNo.value === "") {
    registrationNo.value = 0;
  } else if (registrationNo.value > 9999) {
    registrationNo.value = parseInt(
      registrationNo.value.toString().slice(0, 4)
    );
  } else if (registrationNo.value < 0) {
    registrationNo.value = 0;
  }
}
</script>

<template>
  <!-- Modal -->
  <div
    class="modal fade"
    :id="props.dialogId"
    tabindex="-1"
    aria-labelledby="raceDatePlaceLabel"
    aria-hidden="true"
    :data-bs-theme="darkModeOn ? 'dark' : 'light'"
  >
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="raceDatePlaceLabel">
            {{ props.title }}
          </h5>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
          ></button>
        </div>
        <div class="modal-body">
          <div class="d-flex flex-column">
            <div class="title content_line">
              <div class="item_parent">
                <div class="content_title">
                  <div class="texttitle">登番</div>
                </div>
                <div class="content_item flex-column">
                  <div class="d-flex flex-row mt-2">
                    <input
                      class="registrationNoSelect"
                      type="number"
                      v-model.number="registrationNo"
                      min="0"
                      max="9999"
                      maxlength="4"
                      v-on:input="registrationNoCheck()"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <div class="d-flex flex-row">
            <button
              type="button"
              class="modal_button submit_button"
              data-bs-dismiss="modal"
              @click="onClick('result', { res: false })"
            >
              キャンセル
            </button>
            <button
              type="button"
              class="modal_button submit_button"
              data-bs-dismiss="modal"
              @click="
                onClick('result', {
                  res: true,
                  dialogId: props.dialogId,
                  registrationNo: registrationNo,
                })
              "
            >
              更新
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.modal_button {
  width: 8em;
}

.registrationNoSelect {
  min-height: 2em;
  font-size: 1rem;
  width: 5rem;
  height: 2em !important;
}
</style>
